export default __webpack_public_path__ + "static/media/aws.7b2d3cd5.svg";